module.exports = __webpack_public_path__ + "media/images/x_button-2a7d84e615050ca0d1973f5590e2c4a4.png";